import { Injectable, TemplateRef } from '@angular/core';

import { BehaviorSubject, ReplaySubject } from 'rxjs';

import { TemplateType, TemplateWithType } from '../models/template-type.enum';

import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TemplateReferenceService {

  templates$ = new ReplaySubject<TemplateWithType>();
  linkTemplate$ = new BehaviorSubject<TemplateRef<any>>(null);

  reset() {
    this.templates$ = new ReplaySubject();
  }
  resetLink() {
    this.linkTemplate$ = new BehaviorSubject<TemplateRef<any>>(null);
  }
  addTemplate(templateType: TemplateType, templateRef: TemplateRef<any>) {
    this.templates$.next(new TemplateWithType(templateType, templateRef));
  }

  getTemplates(templateType: TemplateType) {
    return this.templates$.pipe(filter(x => x.templateType === templateType), map(x => x.template));
  }

  addLinkTemplate(templateRef: TemplateRef<any>) {
    this.linkTemplate$.next(templateRef);
  }

  getLinkTemplate() {
    return this.linkTemplate$;
  }
}
